"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var PlaceholderCommon_1 = require("../components/PlaceholderCommon");
function providePlaceholders(vm, componentFactory) {
    var instanceOptions = vm.$options;
    var propsData = instanceOptions.propsData;
    if (typeof instanceOptions.withPlaceholder === 'undefined' ||
        typeof propsData === 'undefined' ||
        typeof propsData.rendering === 'undefined') {
        return;
    }
    // Initialize the computed option if it hasn't already been initialized.
    if (typeof vm.$options.computed === 'undefined') {
        // eslint-disable-next-line no-param-reassign
        vm.$options.computed = {};
    }
    var _a = typeof instanceOptions.withPlaceholder === 'function'
        ? instanceOptions.withPlaceholder()
        : instanceOptions.withPlaceholder, placeholders = _a.placeholders, options = _a.options;
    var renderingData = propsData.rendering;
    var definitelyArrayPlaceholders = !Array.isArray(placeholders) ? [placeholders] : placeholders;
    var computedProps = definitelyArrayPlaceholders.reduce(function (result, placeholderDefinition) {
        var placeholderName = placeholderDefinition.placeholder
            ? placeholderDefinition.placeholder
            : placeholderDefinition;
        var computedPropName = placeholderDefinition.computedPropName
            ? placeholderDefinition.computedPropName
            : placeholderDefinition;
        var placeholderData = PlaceholderCommon_1.getPlaceholderDataFromRenderingData(renderingData, placeholderName);
        if (placeholderData) {
            // eslint-disable-next-line no-param-reassign
            result[computedPropName] = {
                get: function () {
                    return PlaceholderCommon_1.getDynamicComponentsFromRenderingData(placeholderData, __assign({}, propsData, vm.$attrs), vm.$createElement, (options && options.componentFactory) || componentFactory);
                },
            };
        }
        return result;
    }, {});
    vm.$options.computed = __assign({}, vm.$options.computed, computedProps);
}
exports.providePlaceholders = providePlaceholders;
